import styled, { css } from 'styled-components'

import { up } from '@Globals/Style/breakpoints'

interface BarRootProps {
  id?: string
  variant: string
}

export const BarBase = styled.div<BarRootProps>(({ variant }) => css`
  display: flex;
  width: 100%;
  max-width: 100%;
  padding: 5px 20px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: ${variant === 'contained' ? '4px' : 0};
  line-height: 1.5;

  p, h1, h2, h3, h4, h5,h6, span, strong, em {
    padding: 0;
    margin: 0;
    font-size: 11px;
    line-height: 1.5;
    text-align: center;
    ${up('tablet')}{
      font-size: 12px;
    }
  }
`)
